import { parse } from 'hub-http/helpers/params';
import { isValidCurrencyCodeForQueryParam } from './currencyTypes';
export const parseQueryParams = queryString => {
  const queryParams = parse(queryString.replace('?', ''));
  Object.keys(queryParams).forEach(key => {
    const value = queryParams[key];
    let adaptedValue;
    try {
      /*
      This is the case when multiple values for the same queryParam key are passed in.
      For example
        parse(products=marketing-hub-professional_1&products=core-seats-professional_0&term=annual)
      returns
        {
          products: ['marketing-hub-professional_1', 'core-seats-professional_0'],
          term: 'annual'
        }
        While
          parse(products=marketing-hub-professional_1&term=annual)
        returns
        {
          products: 'marketing-hub-professional_1',
          term: 'annual'
        }
      */
      if (Array.isArray(value)) {
        adaptedValue = value.map(val => JSON.parse(val));
      } else {
        adaptedValue = JSON.parse(value);
      }
    } catch (e) {
      adaptedValue = value;
    }
    queryParams[key] = adaptedValue;
  });
  return queryParams;
};
export const getQueryParams = () => parseQueryParams(window.location.search);
const TIER_PARAM = 'tier';
export function getTierFromSearch(search) {
  const params = new URLSearchParams(search);
  return params.get(TIER_PARAM) || undefined;
}
export const getCurrencyCodeParam = (queryParams, availableCurrencyCodes) => {
  const {
    currencyCode: currencyCodeParam
  } = queryParams;
  if (!currencyCodeParam) {
    return null;
  }
  const currencyCode = Array.isArray(currencyCodeParam) ? currencyCodeParam[0] : currencyCodeParam;
  if (!isValidCurrencyCodeForQueryParam(currencyCode, availableCurrencyCodes)) {
    return null;
  }
  return currencyCode;
};